<script setup>
import { computed, onMounted, watch } from 'vue';
import { useSharedModal } from '@vuejs/composables/useSharedModal';
import Loader from '@vuejs/components/Loader.vue';

const sharedModal = useSharedModal();

onMounted(() => {
    window.addEventListener('DOMContentLoaded', () => {
        let eventAttached = false;

        const modalElement = document.querySelector('#shared-modal-app');

        // if (window.IS_MOBILE) {
        //     modalElement.classList.add('modal-bottom')
        // } else {
        //     modalElement.classList.add('modal-end')
        // }

        const modalInstance = new window.bootstrap.Modal(modalElement, {
            backdrop: 'static',
            keyboard: false,
        });

        window.bootstrap.modal = modalInstance;

        window.bootstrap.modal._element.addEventListener('shown.bs.modal', () => {
            if (!eventAttached) {
                console.log(window.bootstrap.modal._backdrop._element);

                window.bootstrap.modal._backdrop._element.addEventListener('click', () => {
                    console.log('click');

                    sharedModal.hide();
                });
            }

            eventAttached = true;
        });

        window.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && sharedModal.getCurrent) {
                sharedModal.hide();
            }
        });
    });

    window.addEventListener('vue.modal.show', ({ detail: { componentName, payload } }) => {
        // console.log({ componentName, payload });
        sharedModal.show(componentName, payload);
    });

    window.addEventListener('vue.modal.replace', ({ detail: { componentName, payload } }) => {
        sharedModal.replace(componentName, payload);
    });

    window.addEventListener('vue.modal.hide', (e) => {
        sharedModal.hide();
    });

    window.addEventListener('vue.modal.hide-all', (e) => {
        sharedModal.hideAll();
    });
});

const current = computed(() => sharedModal.getCurrent.value);
const close = () => {
    if (!current.value) return;
    current.value.closeAllOnX ? sharedModal.hideAll() : sharedModal.hide();
};

const backIcon = computed(() =>
    current.value?.closeAllOnX || sharedModal.getAmount.value === 1
        ? ['fal', 'xmark']
        : ['fal', 'angle-left']
);
const backLabel = computed(() =>
    current.value?.closeAllOnX || sharedModal.getAmount.value === 1 ? null : 'global.go-back'
);
</script>

<template>
    <div
        class="modal-dialog"
        :class="[
            sharedModal.modalOptions.value.size,
            { 'modal-dialog-centered': sharedModal.modalOptions.value.centered },
        ]"
    >
        <div class="modal-content rounded-0 border-none">
            <span
                class="p-5 px-lg-6 py-lg-5 position-absolute top-0 end-0 cursor-pointer z-1 x-mark"
                @click="close"
            >
                <font-awesome-icon :icon="backIcon" class="fs-5 me-2" />
                <span v-if="backLabel" class="fs-6 text-capitalize text-custom-5">
                    {{ $t(backLabel) }}
                </span>
            </span>

            <template v-if="sharedModal.getCurrent.value">
                <KeepAlive>
                    <Suspense timeout="0">
                        <component
                            :is="sharedModal.getCurrent.value.component"
                            v-bind="sharedModal.getCurrent.value.payload"
                        >
                        </component>

                        <template #fallback>
                            <Loader />
                        </template>
                    </Suspense>
                </KeepAlive>
            </template>
        </div>
    </div>
</template>
